
import * as angular from "angular";
import {ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import "./get-student-modal.less";
import {StateService} from "@uirouter/angularjs";

class GetStudentModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public applicantId: string = "";
    public studentId: string = "";
    public form: any;
    public showErrors: boolean;



    /* @ngInject */
    constructor(private $log: ILogService, private $state: StateService) {
    }

    public $onInit() {
        this.$log.debug(this.form);
    }

    public submit() {
        this.modalInstance.close({studentId: this.studentId, applicantId: this.applicantId});
    }

    public cancel() {
        this.modalInstance.dismiss(false);
    }

}

export const GetStudentModalComponent: angular.IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "=",
    },
    controller: GetStudentModalController,
    template: require("./get-student-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/dashboard/get-student-modal.component.ts